import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions, Rules } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
declare var $: any;

import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { Group } from 'src/app/common-class/pages';
import { PreviewData } from 'src/app/common-class/survey';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.css'],
 // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() group: Group;
  @Input() isGrid: boolean;
  @Input() radiolength:number;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions;
  qdlQuestions: Questions[] = [];
  answerImagesLength: number;

  columnWidth: any;

  tempArray = [];
  answersArray: any;
  singleImageArray: Array<number> = [];
  multiImageArray: Array<number> = [];
  inLineRuleArray: Array<string> = [];
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any = false;
  nextButtonClickSub: any;
  isNewParticipation: any;
  surveyFormat:number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean;
  isOtherQuestion:boolean=false;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  isQDLNewParticipationButton: boolean = false;
  AsteriskMandatory :string ="";

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.answerPipingMessageDisplayed();

      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }
      this.inLineRuleArray.length = 0;
      if (this.questions.qsubtype == 0 || this.questions.qsubtype == 7) {
        if (this.questions.DispAnsCol > 1) {
          // for (let i = 0; i < this.questions.Answers.length; i++) {
          //   let id = "td_Q" + this.questions.qno + "_" + this.questions.UniqueNumber + "_" + this.questions.Answers[i].value_id;
          //   $('#' + id).find('input').prop('checked', false);
          //   $('#' + id).find('label').removeClass('selectedAnsOpt');
          // }
          if ((this.questions.DispAnsCol > 1) && this.questions.Answers != null) {
            this.HorizontalAndVerticalHandling();
          }
        }

        this.ngAfterViewInit();

      }

      if(this.questions.qsubtype == 1){
        let id = "div_Q" + this.questions.qno + "_" + this.questions.UniqueNumber + "_ID";
        $('#'+id+' input[type="radio"]').prop('checked', false);
        this.ngAfterViewInit();
      }
    }
  }

  constructor(private service: ParticipationDataService, private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData) { }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      this.answerPipingMessageDisplayed();
      this.AsteriskMandatory=this.service.getSurveyMessages().AsteriskMandatory;
      let updateItem = this.questions.Answers.find(
        e => (e.hasImage && e.AnswerImages.length == 2 || e.hasMedia && e.AnswerMedias.length == 2) ||
        (e.hasImage && e.AnswerImages.length == 1 && e.hasMedia && e.AnswerMedias.length == 1));

      if(this.questions.Answers.filter(e => e.isOther).length > 0){
        this.isOtherQuestion = true;
      }
      if(this.questions.population_type == 3)
      {
        this.isAnsChange = true;
      }
      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }

      } else {
        updateItem = this.questions.Answers.find(
          e => (e.hasImage && e.AnswerImages.length == 1 || e.hasMedia && e.AnswerMedias.length == 1));

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      var hiddenAnswers = this.questions.Answers.filter(e=> e.isHide ==false && e.isQuotaHide == false)
      if(hiddenAnswers.length > 0 && this.questions.qtype == "R" && this.questions.qsubtype == 1)
      {
        this.questions.Answers = hiddenAnswers;
      }


      if (this.questions.answer_style == 1 && this.questions.RotateIndex == 0 && this.questions.Answers != null) {
        this.RandomAnswerHandling();
      }

      if ((this.questions.DispAnsCol > 1) && this.questions.Answers != null) {
        this.HorizontalAndVerticalHandling();
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    if(this.questions.qtype == "HR"){
      this.answerImagesLength = 0;
    }

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton = this.isNewParticipationButton && (!this.service.isAutoScroll || this.questions.population_type==3);
  }

  ngAfterViewInit() {
    if(window.navigator.userAgent.indexOf("Chrome") != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
      // $('.question-option-wrapper').css('width', 'calc(100% + 1px)');
    }

    var self = this;
    if (this.questions.qsubtype == 1) {
      setTimeout(() => {
        var holderHeight = 0, holderpadding = 0;
        $('.image-choice-wrapper').each(function () {
          if (holderHeight < $(this).find('.ic-image-holder:visible').outerWidth()) {
            holderHeight = $(this).find('.ic-image-holder:visible').outerWidth();
          }
          $(this).find('.ic-image-holder').each(function () {
            if ($(this).hasClass('showReportValue')) {
              if (holderpadding < $(this).find('.ic-report-value:visible').outerHeight()) {
                holderpadding = $(this).find('.ic-report-value:visible').outerHeight();
              }
            }
          });
        })
        $('.image-choice-wrapper').each(function () {
          if ($(this).find('.ic-label').eq(0).hasClass('medium')) {
            $(this).find('.ic-image-holder').addClass('medium');
          } else if ($(this).find('.ic-label').eq(0).hasClass('small')) {
            $(this).find('.ic-image-holder').addClass('small');
          } else {
            $(this).find('.ic-image-holder').addClass('large');
          }

          $(this).find('.ic-image-holder').each(function() {
            if($(this).hasClass('showReportValue')){
              // $(this).css('padding-bottom', $(this).find('.ic-report-value:visible').outerHeight() + 'px');
              $(this).css('padding-bottom', holderpadding + 'px');
              $(this).find('.ic-report-value').css('height', holderpadding + 'px');
            }
          });

          // $(this).find('.ic-image-holder').height($(this).find('.ic-image-holder').outerWidth());
          $(this).find('.ic-image-holder').height(holderHeight);
        })
      }, 50);
      $(window).on('resize', function () {
        $('.ic-image-holder:visible').height($('.ic-image-holder:visible').outerWidth());
      });


    } else if (this.questions.DispAnsCol > 1) {
      $('document').ready(function () {
        for (let i = 0; i < self.questions.Answers.length; i++) {
          let id = "td_Q" + self.questions.qno + "_" + self.questions.UniqueNumber + "_" + self.questions.Answers[i].value_id;
          $('#' + id).unbind().click(function (event) {
            let checkedValue;
            event.stopPropagation();
            if (!$(this).hasClass('hrb-disabled')) {
              // if ($(this).find('input[type="radio"]').prop('checked') === false && $(this).find('input[type="radio"]').length > 0) {
              //   $(this).parents('.answer-option-wrapper').find('input[type="radio"]').prop('checked', false);
              //   $(this).parents('.answer-option-wrapper').find('.radio-hrb').removeClass('selected');
              //   $(this).find('input[type="radio"]').prop('checked', true);
              //   $(this).addClass('selected');
              //   checkedValue = true;
              // } else {
              //   $(this).find('input[type="radio"]').prop('checked', false);
              //   $(this).removeClass('selected');
              //   checkedValue = false;
              // }

              // let currentInputValueArray = $(this).find('input[type="radio"]').attr('id').split('_R_');
              // let currentInputValue = currentInputValueArray[1].split('_');
              // self.SortValue(currentInputValue[0], checkedValue, self);
              self.clickEventHandle(self.questions.Answers[i]);
              self.nextQuestion(event.target);

            }
          });
        }
      });
    }

    this.isAriaRequired = (this.questions.mandatory && this.isMandatoryUpfront) || (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);

    this.isCapchaManditorySkip = this.service.getIsCapchaMandatorySkip();
    this.pageIsSoftRequiredHandle = this.service.getPageIsSoftRequiredHandle();
    this.nextButtonClickNo = this.service.getNextButtonClickNo() == undefined ? 0 : this.service.getNextButtonClickNo();
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
      }
    });
  }

  ngOnDestroy(){
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  answerPipingMessageDisplayed(){
    if (this.previewData != undefined && this.service.getPrevPgChnge() && //this.previewData.isPrevPgChnge &&
      this.questions.AnsPipeCondition != 0 && this.questions.AnsPipeCondition != 1 &&
      this.questions.AnsPipeCondition != 3 && this.questions.AnsPipeCondition != 4) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }
  }

  SortValue(valueId: any, curVal, self) {

    let ans = self.questions.Answers.find(e => e.value_id == valueId);

    if (ans != null && ans != undefined) {
      if (curVal) {
        ans.ControlAns = ans.value_text;
        this.SelectedValue(ans);
      } else {
       this.ClickEventHandling(ans);
      }
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length, temporaryValue, randomIndex;
    let updateItem = this.questions.Answers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  HorizontalAndVerticalHandling() {
    let DispAnsCol = this.questions.DispAnsCol;

    let qShowAnswers = this.questions.Answers.filter(e=>e.isADLHide == false)

    let answerLength = qShowAnswers.length;

    let updateItem = qShowAnswers.find(e => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      answerLength -= 1;
    }
    let rowCount = Math.ceil(answerLength / DispAnsCol);

    this.columnWidth = (100 / DispAnsCol);

    if (this.questions.DispAnsFormat == 1) {  //Vertical
      let ansArray = [];
      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let index = 0;
        for (let j = i; j < answerLength; j = j + rowCount) {
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage) {
            this.SingleAndMultiImageHandling(index, j);
          }

          index++;
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }
      // this.tempArray[0] = ansArray;
      this.answersArray = ansArray;

    } else if (this.questions.DispAnsFormat == 2 || this.questions.qtype == "HR") { //Horizontal
      let ansArray = [];

      for (let i = 0; i < rowCount; i++) {
        let tempArray = [];
        let counter = 0;
        let index = 0;
        for (let j = (i * DispAnsCol); j < answerLength; j++) {
          counter++;
          tempArray.push(qShowAnswers[j]);

          if (qShowAnswers[j].hasImage) {
            this.SingleAndMultiImageHandling(index, j);
          }
          index++;

          if (counter == DispAnsCol) {
            break;
          }
        }

        ansArray.push(tempArray);
      }
      if (updateItem != undefined && updateItem != null) {
        let tempArray = [];
        tempArray.push(updateItem);
        ansArray.push(tempArray);
      }

     // this.tempArray[0] = ansArray;
     this.answersArray = ansArray;
    }

    //this.answersArray = this.tempArray;
  }

  SingleAndMultiImageHandling(index: number, j: number) {
    if ((this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length > 1) ||
      (this.questions.Answers[j].AnswerImages != null &&
      this.questions.Answers[j].AnswerImages.length > 1) ||
      this.multiImageArray.indexOf(index) >= 0) {

      if (this.multiImageArray.indexOf(index) < 0) {
        this.multiImageArray.push(index);
      }

      if (this.singleImageArray.indexOf(index) >= 0) {
        this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
      }
    } else if((this.questions.Answers[j].AnswerMedias != null &&
      this.questions.Answers[j].AnswerMedias.length == 1) &&
      (this.questions.Answers[j].AnswerImages != null &&
        this.questions.Answers[j].AnswerImages.length == 1)){
          if (this.multiImageArray.indexOf(index) < 0) {
            this.multiImageArray.push(index);
          }

          if (this.singleImageArray.indexOf(index) >= 0) {
            this.singleImageArray.splice(this.singleImageArray.indexOf(index), 1);
          }
    }
    else {
      if (this.singleImageArray.indexOf(index) < 0) {
        this.singleImageArray.push(index);
      }
    }

  }

  HasSingleImageClass(index: number): boolean {
    if (this.singleImageArray.indexOf(index) >= 0) {
      return true;
    }
    else {
      return false;
    }
  }

  HasMultiImageClass(index: number): boolean {
    let abc = index;
    if (this.multiImageArray.indexOf(index) >= 0) {
      return true;
    }
    else {
      return false;
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  SelectedValue(answer: Answers) {
    if (this.questions != null) {
      for (let i = 0; i < this.questions.Answers.length; i++) {
        if (answer.ms_id === this.questions.Answers[i].ms_id) {
          answer.selectdId = 1;
          answer.ControlAns = answer.value_text;
          this.questions.Answers[i] = answer;
          this.questions.AnswerID = answer.ms_id;
          this.questions.selectAnsValue = answer.value_id;
          this.questions.AnswerText = answer.ControlAns;
          this.questions.pageto = answer.pageto;
          this.questions.otherAnswer = null;

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            this.questions.isOtherAnswer = true;
          }
          else {
            this.questions.isOtherAnswer = false;
          }
        }
        else {
          this.questions.Answers[i].ControlAns = null;
          this.questions.Answers[i].selectdId = 0;
        }
      }
      if(this.isNewParticipation){
        if (this.questions.rules != null) {
          this.CheckSelectdValueHaveInlineQDL();
        }
        this.changeDetect.detectChanges();
      }
      this.UpdateQuestionsData(this.questions);
      //this.ChangeAnswersData.emit(this.questions);
    }
  }

  CheckSelectdValueHaveInlineQDL(){
    let rules = this.questions.rules.filter(e => e.InlineQDL);

    if(rules != null && rules.length > 0){

      for (let index = 0; index < rules.length; index++) {
        if(this.loadInlineQDL(rules[index].Rule_id) != null){
          this.isQDLNewParticipationButton = true;
          break;
        }else{
          this.isQDLNewParticipationButton = false;
        }
      }
    }
  }

  ClickEventHandling(answer: Answers) {
    if (answer.selectdId == 0) {
      return;
    }
    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = this.questions.Answers.find(this.findIndexToUpdate, answer);
      let index = this.questions.Answers.indexOf(updateItem);
      this.questions.Answers[index] = answer;
      this.questions.AnswerID = 0;
      this.questions.selectAnsValue = 0;
      this.questions.pageto = 0;
      this.questions.AnswerText = null;
      this.questions.otherAnswer = null;
      this.questions.isOtherAnswer = false;
      //this.ChangeAnswersData.emit(this.questions);
      if(this.isNewParticipation){
        if (this.questions.rules != null) {
          this.CheckSelectdValueHaveInlineQDL();
        }
        this.changeDetect.detectChanges();
      }
      this.UpdateQuestionsData(this.questions);

      if (this.questions.isSoftRequired) {
        this.questions.isSoftRequiredHandle = false;
      }
    }
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, rule_id: number): string {  
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    if(this.questions.isOtherAnswer || this.showNewParticipationButton)
    {
    this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {

    if (answer.value_id == 1) {
      return this.group.L_text;
    } else if (this.group.M_Pos == parseInt(answer.value_text)) {
      return this.group.M_text;
    } else {
      let max = question.Answers.reduce((prev, current) => (prev.value_id > current.value_id) ? prev : current);
      if (max != null && max != undefined) {
        if (max.weight == 0) {
          if (answer.value_text == "") {
            return '';
          } else if (answer.value_text != null) {
            if ((max.value_id - 1) == (answer.value_id) && answer.weight != null && answer.weight != 0) {
              return this.group.H_text;
            } else if (answer.value_text != null && max.value_id == answer.value_id) {
              if (answer.value_text != null) {
                return answer.value_text;
              }
              return;
            }
          }
        }
        else if (max.value_id == answer.value_id && answer.weight != 0) {
          return this.group.H_text;
        }
        return;
      }
    }
  }

  getAnsImageMediaCSS(answer: Answers) {
    if (answer == undefined) {
      return '';
    }
    if ((answer.hasImage == true && answer.AnswerImages.length == 1 && answer.hasMedia == false) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 1 && answer.hasImage == false)) {
      return 'single-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 1) &&
      (answer.hasMedia == true && answer.AnswerMedias.length == 1)) {
      return 'multi-ans-image';
    }
    else if ((answer.hasImage == true && answer.AnswerImages.length == 2) ||
      (answer.hasMedia == true && answer.AnswerMedias.length == 2)) {
      return 'multi-ans-image';
    }
    else {
      return '';
    }
  }

  onBlurMethod() {
    if (this.questions.AnswerText == "") {
      this.questions.AnswerText = null;
    }

    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsData(this.questions);
  }

  loadInlineQDL(rule_Id: number) : Questions{
    if (this.questions.rules != null && this.questions.rules.length > 0) {
      this.nextButtonClickNo=  this.service.getNextButtonClickNo();
      let updateItem = this.questions.rules.filter(e => e.Rule_id == rule_Id && e.InlineQDL);

      if (updateItem != null && updateItem != undefined) {
        
       return this.newInlineQDLHandling(updateItem);
      }
    }
  }
  checkifInlineisLoaded(answer:Answers):boolean
  {
    if(this.inLineRuleArray.indexOf(answer.Rule_id + "_" + answer.value_id) == -1)
    {
      this.inLineRuleArray.push(answer.Rule_id+ "_" + answer.value_id);
      return true;
    }
    else
    {
        return false;
    }
  }
  newInlineQDLHandling(rule: Rules[]): Questions {

    for (let k = 0; k < rule.length; k++) {
      let value = rule[k].ConditionValue.split(',');

      if (value != undefined && value != null) {
        let count: number = 0;
        for (let i = 0; i < value.length; i++) {

          if (this.questions.selectAnsValue == parseInt(value[i])) {
            count++;
          }
        }
        if(this.newOperatorValid(rule[k], count, value) != null)
        {
           return this.newOperatorValid(rule[k], count, value);
        }
      }
    }
  }

  newOperatorValid(updateItem: Rules, count: number, value: any): Questions {
    if (updateItem.Operator == 'OR' && count <= value.length && count != 0 && this.questions.AnswerText != null) {
      return this.newLoadQDL(updateItem);
    } else if ((updateItem.Operator == 'NOT' && count == 0)) {
      return this.newLoadQDL(updateItem);
    } else if ((updateItem.Operator == 'ISANSWERED' && this.questions.AnswerText != null)) {
      return this.newLoadQDL(updateItem);
    } else if ((updateItem.Operator == 'ISNOTANSWERED' && this.questions.AnswerText == null)) {
      return this.newLoadQDL(updateItem);
    } else {
      return null
    }
  }

  newLoadQDL(updateItem: Rules) : Questions {
    let qn = this.service.GetQDL(updateItem.ConditionQID);

    if (qn != undefined && qn != null) {
      if (!qn.isLoading) {
        qn.isLoading = true;
        this.ChangeLoadingAnswersData.emit(qn);
      }
    }
    return this.service.GetQDL(updateItem.ConditionQID);
  }



  loadDestinationQn(rule_Id: number): Questions {

    if (this.questions.DestinationQuestions != null &&
      this.questions.DestinationQuestions != undefined) {

      if (this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id) != undefined) {
        let qn = this.service.GetQDL(this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id).ConditionQID);

        if (qn != undefined && qn != null) {
          if (!qn.isLoading) {
            qn.isLoading = true;
            this.ChangeLoadingAnswersData.emit(qn);
          }
        }

        return this.service.GetQDL(this.questions.DestinationQuestions.find(e => e.rule_id == rule_Id).ConditionQID);
      } else {
        return null;
      }
    }
  }

  nextQuestion(event) {
    if (this.isNewParticipation && (this.surveyFormat == 1 ||  this.surveyFormat == 2) && (this.questions.ansConstraint == null || this.questions.isMatrixQuestion) && this.service.isAutoScroll && !this.isQDLNewParticipationButton) {
      let self = this;
      setTimeout(() => {
        if (self.questions.selectAnsValue != 0) {
          if ((self.questions.qtype == "SR" || self.questions.qtype == "GR" || self.questions.qtype == "RG" || self.questions.qtype == "RW") ) {
            var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
            var nextbtnLength1 = $(event).closest('.inactive-ques').nextAll('.active-ques').has('.question-data').length;
             var elemPosition;
              elemPosition = $(event).closest('.matrix-standalone-active-ques' + self.questions.group_no).nextAll('.matrix-standalone-active-ques' + self.questions.group_no)
              var MatrixelemPosition;
              MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
              //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
              var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')

              if (elemPosition.length > 0) {
                elemPosition = $(event).closest('.matrix-standalone-active-ques' + self.questions.group_no).nextAll('.matrix-standalone-active-ques' + self.questions.group_no).has('.question-data').eq(0).offset().top;
                $('html,body').animate({
                  scrollTop: (elemPosition - $(window).height() / 3)
                }, 400);
              }else if (MatrixelemPosition.length > 0) {
                MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
                //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
                //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
                $('html,body').animate({
                  scrollTop: (MatrixelemPosition - $(window).height() / 3)
                }, 400);
              }else if (MatrixelemPosition1.length > 0) {
                //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
                //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
                MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
                $('html,body').animate({
                  scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
                }, 400);
              } else if (nextbtnLength > 0) {
                elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
                $('html,body').animate({
                  scrollTop: (elemPosition - $(window).height() / 3)
                }, 400);
              }else if (nextbtnLength1 > 0) {
                elemPosition = $(event).closest('.inactive-ques').nextAll('.active-ques').has('.question-data').eq(0).offset().top;
                $('html,body').animate({
                  scrollTop: (elemPosition - $(window).height() / 3)
                }, 400);
              }else{
                var scrollVal = $('.tblPageFooter').offset().top;
                $('html,body').animate({
                  scrollTop: scrollVal
                }, 400);
              }
          } else {
            if (!((((self.questions.qtype == "RW" || self.questions.qtype == "RG") && self.questions.qsubtype == 1) || ((self.questions.qtype == "GR"||self.questions.qtype == "SR") && self.questions.qsubtype == 0)) && self.radiolength > 1)) {
              // $(event).closest('.main-ques-cont').find('.ques-response-btn-div').hide();
              // var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
              // if (nextbtnLength > 0) {
              //   var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
              //   $('html,body').animate({
              //     scrollTop: (elemPosition - $(window).height() / 3)
              //   }, 400);
              // } else {
              //   var scrollVal = $('.tblPageFooter').offset().top;
              //   $('html,body').animate({
              //     scrollTop: scrollVal
              //   }, 400);
              // }

              this.service.gotoNextQuestion(this.questions,event);

            }
          }
        } else {
          $(event).closest('.main-ques-cont').find('.ques-response-btn').show();
        }
      }, 1);
    }
    else if (this.surveyFormat == 3) {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find(".question-data").attr("hidden");

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }

  // HidenewParticipationBtn(event){
  //   if (this.isNewParticipation && this.surveyFormat == 1 && this.questions.ansConstraint == null && !this.questions.isMatrixQuestion) {
  //     $(event).closest('.main-ques-cont').find('.ques-response-btn-div').hide();
  //   }
  // }

  gotoNextQuestion(question: Questions, event) {
    if (this.isStandAlone) {
      var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;

        var elemPosition;
        elemPosition = $(event).closest('.matrix-standalone-active-ques' + question.group_no).nextAll('.matrix-standalone-active-ques' + question.group_no)

        var MatrixelemPosition;
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
        //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id)
        var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
        if (elemPosition.length > 0) {
          elemPosition = $(event).closest('.matrix-standalone-active-ques' + question.group_no).nextAll('.matrix-standalone-active-ques' + question.group_no).has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (elemPosition - $(window).height() / 3)
          }, 400);
        }else if (MatrixelemPosition.length > 0) {
          MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition - $(window).height() / 3)
          }, 400);
        }else if (MatrixelemPosition1.length > 0) {
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
          }, 400);
        } else if (nextbtnLength > 0){
          elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (elemPosition - $(window).height() / 3)
          }, 400);
        }else{
          var scrollVal = $('.tblPageFooter').offset().top;
          $('html,body').animate({
            scrollTop: scrollVal
          }, 400);
        }
    } else {
      this.service.gotoNextQuestion(question, event);
    }
  }

  clickEventHandle(answer: Answers) {
    if (answer.selectdId == 0) {
      this.SelectedValue(answer);
    } else {
      this.ClickEventHandling(answer);
    }
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  getAnswerPipeMessage(): string{
    return this.service.getAnswerPipeMessage();
  }
}
